var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "align-center mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-1 text-subtitle-2 font-weight-medium"
  }, [_vm._t("label")], 2)]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.expanded = !_vm.expanded;
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.expanded ? "mdi-chevron-up" : "mdi-chevron-down"))])], 1)], 1)], 1), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expanded,
      expression: "expanded"
    }]
  }, [_vm._t("default")], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }